enum SessionStatus {
  active = 'active',
  expired = 'expired',
  unknown = 'unknown',
}

export default SessionStatus;
